// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__uXhL4","label":"Loader_label__ievY9"};